import { deleteRequest, getRequest, patchRequest, postRequest, putRequest } from "../../utils/apiHelper";
import type { CreatePipelineRequest } from "../../containers/Pipelines/types";

// Get the default (and only) pipeline for the agency
const getDefaultPipeline = async (): Promise<any> => {
  const response = await getRequest("pipelines");
  return response;
};

// Create new stage
const createStage = async (pipelineId: number, stageData: { name: string; tag_name: string; order_index: number }): Promise<any> => {
  try {
    const response = await postRequest(`pipelines/${pipelineId}/stages`, stageData, false, undefined, "default", undefined);
    return response;
  } catch (error) {
    console.log("❌ pipelineService.createStage error:", error);
    throw error;
  }
};

// Update stage tag
const updateStageTag = async (pipelineId: number, stageId: number, tagId: string): Promise<any> => {
  const response = await patchRequest(`pipelines/${pipelineId}/stages/${stageId}`, { tag_name: tagId }, false, undefined, "default");
  return response;
};

// Update pipeline
const updatePipeline = async (id: number, params: Partial<CreatePipelineRequest>): Promise<any> => {
  const response = await putRequest(`pipelines/${id}`, params, false, "default");
  return response;
};

// Delete pipeline
const deletePipeline = async (id: number): Promise<any> => {
  const response = await deleteRequest(`pipelines/${id}`, false, "default");
  return response;
};

// Reorder stages (batch update order_index)
const reorderStages = async (pipelineId: number, stages: Array<{ id: number; order_index: number }>): Promise<any> => {
  const response = await putRequest(`pipelines/${pipelineId}/stages/reorder`, { stages }, false, "default");
  return response;
};

export const pipelineService = {
  getDefaultPipeline,
  createStage,
  updateStageTag,
  updatePipeline,
  deletePipeline,
  reorderStages,
};
